import $axiosProtected from "../../../common/utils/axiosUtils";

// Get list of all doctor details
export const getDoctorInsights = async (payload: any) => {
  return await $axiosProtected().get(
    `/scheduler/schedule-consultation/doctor/insights/get?fromDate=${payload.fromDate}&toDate=${payload.toDate}&doctorId=${payload.doctorId}&facilityCode=${payload.facilityCode}`
  );
};
